import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './EditPost.module.css'
import { Divider, Stack, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { MuiDropdown } from '../../../components/common/dropdown/mui-dropdown/MuiDropdoown'
import { MuiTextArea } from '../../../components/common/mui-text-area/MuiTextArea'
import { MuiTextField } from '../../../components/common/textfield/MuiTextField'
import { createPostRedux } from '../../../redux/create-post-redux/CreatePostRedux'
import { loginRedux } from '../../../redux/login-redux/LoginRedux'
import routesNames from '../../../routes/RouteNames'
import { CustomAudioPlayer } from '../../../components/common/audio-player/AudioPlayer'
import VideoPlayer from '../../../components/common/video-player/VideoPlayer'
import { MediaTypeEum } from '../../../core/enumerations/MediaTypeEnum'
import strings from '../../../strings/Strings'
import RenderHtml from '../../../components/common/render-html/RenderHtml'
import CustomAvatar from '../../../components/common/avatar/MuiAvatar'

const EditPost = () => {
  const location = useLocation()
  const audioRefs: any = useRef([]);
  const navigate = useNavigate()

  const loginState = useSelector((state: any) => state.Login);
  const createPostState = useSelector((state: any) => state.createPostRedux)

  const actionDispatch = (dispatch: any) => ({
    getAllCategories: () =>
      dispatch(loginRedux.actions.getAllCategoriesRequest()),
    updatePost: (data: any) =>
      dispatch(createPostRedux.actions.updatePostRequest(data)),
    setCreatePostState: (data: any) =>
      dispatch(createPostRedux.actions.setCreatePostState(data)),
  });

  const { getAllCategories, updatePost, setCreatePostState } = actionDispatch(useDispatch());

  const [postsData, setpostsData] = useState(location?.state?.postDetails?.postMedias);
  const [postDetails, setPostDetails] = useState({
    title: location?.state?.postDetails?.title,
    description: location?.state?.postDetails?.description,
    categoryId: location?.state?.postDetails?.categoryId,
  });

  useEffect(() => {
    getAllCategories()
  }, [])

  useEffect(() => {
    if (createPostState?.isPostDetailsUpdated) {
      setCreatePostState({
        key: "isPostDetailsUpdated", value: false
      })
      handleCancel()
    }
  }, [createPostState.isPostDetailsUpdated])

  const handleChange = (event: any) => {
    const { name, value } = event.target
    setPostDetails({
      ...postDetails,
      [name]: value
    })
  }

  const handleCancel = () => {
    navigate(routesNames.profile)
  }

  const handleSave = () => {
    const reqBody = {
      postId: location?.state?.postDetails?.id,
      data: postDetails
    }
    updatePost(reqBody)
  }
  
  const handlePlayPause = (index: number, selectedMedia: any) => {
    const viewPostMedia = postsData?.map((media: any, mediaIndex: any) => {
      if (
        media?.mediaType === MediaTypeEum.voice ||
        media?.mediaType === MediaTypeEum.video
      ) {
        if (index === mediaIndex) {
          if (media.isPlaying) {
            audioRefs.current[index]?.pause();
          } else {
            audioRefs.current[index]?.play();
          }
          return {
            ...media,
            isPlaying: !media?.isPlaying,
          };
        } else {
          if (media?.isPlaying) {
            const prevMedia: any = document.getElementById(
              `${media.url}+${mediaIndex}+${media.id}`
            );
            prevMedia?.pause();
          }
          return {
            ...media,
            isPlaying: false,
          };
        }
      } else {
        return media;
      }
    });
    setpostsData(viewPostMedia);
  };

  const handleUnMute = (index: number, selectedMedia: any) => {
    const viewPostMedia = postsData?.map((media: any, mediaIndex: any) => {
      if (
        media?.mediaType === MediaTypeEum.voice ||
        media?.mediaType === MediaTypeEum.video
      ) {
        if (mediaIndex === index) {
          return {
            ...media,
            isMute: false,
          };
        } else {
          return media;
        }
      } else {
        return media;
      }
    });
    setpostsData(viewPostMedia);
  };

  const handleMute = (index: number, selectedMedia: any) => {
    const viewPostMedia = postsData?.map((media: any, mediaIndex: any) => {
      if (
        media?.mediaType === MediaTypeEum.voice ||
        media?.mediaType === MediaTypeEum.video
      ) {
        if (mediaIndex === index) {
          return {
            ...media,
            isMute: true,
          };
        } else {
          return media;
        }
      } else {
        return media;
      }
    });
    setpostsData(viewPostMedia);
  };

  return (
    <div className={styles["main-container"]}>
      <div className={styles["container"]}>
        <Stack className={styles["header-container"]}>
          <Stack className={styles["profile-details"]}>
            <CustomAvatar
              numberOfAvatars={1}
              imageAvatars={[
                { id: 1, imageUrl: location?.state?.postDetails?.userDetails?.profilePic },
              ]}
              variant={"circular"}
              sx={{ width: "4rem", height: "4rem" }}
            />
            <Typography>{location?.state?.postDetails?.userDetails?.userName}</Typography>
          </Stack>
          <Stack className={styles["buttons-container"]}>
            <span onClick={handleCancel}>{strings.cancel}</span>
            <Typography onClick={handleSave}>{strings.done}</Typography>
          </Stack>
        </Stack>

        <Divider />

        <Stack className={styles["sub-container"]}>
          <div className={styles["posts-container"]}>
            {postsData?.map((media: any, index: number) => {
              if (media.mediaType === MediaTypeEum.text) {
                return <RenderHtml url={media.url} />;
              }
              if (media.mediaType === MediaTypeEum.image) {
                return (
                  <div key={index}>
                    <img
                      alt="artist-post"
                      className={styles["artist-posts"]}
                      src={media.url}
                    />
                  </div>
                );
              }
              if (media.mediaType === MediaTypeEum.video) {
                return (
                  <div key={index}>
                    <VideoPlayer
                      videoUrl={media?.url}
                      data={media}
                      index={index}
                      audioRefs={audioRefs}
                      handlePlayPause={handlePlayPause}
                      handleMute={handleMute}
                      handleUnMute={handleUnMute}
                    />
                  </div>
                );
              }
              if (
                media.mediaType === MediaTypeEum.voice ||
                media.mediaType === MediaTypeEum.audio
              ) {
                return (
                  <div key={index} className={styles["audio-container"]}>
                    <CustomAudioPlayer
                      data={media}
                      audioUrl={media.url}
                      index={index}
                      audioRefs={audioRefs}
                      handlePlayPause={handlePlayPause}
                      handleMute={handleMute}
                      handleUnMute={handleUnMute}
                    />
                  </div>
                );
              }
            })}
          </div>
          <div className={styles["fields-container"]}>
            <Stack direction={"column"} rowGap={4}>
              <MuiTextField
                fullWidth
                type="text"
                name="title"
                value={postDetails.title}
                onChange={(event: any) => handleChange(event)}
                inputProps={{ "data-testid": "project-title", maxLength: 60 }}
                label={strings.postTitle}
                errormessage=""
                shouldDisplayError={true}
              />
              <MuiTextArea
                fullWidth
                type="text"
                maxLength={500}
                name="description"
                onChange={(event: any) => handleChange(event)}
                value={postDetails.description}
                multiline
                rows={4}
                maxRows={4}
                inputProps={{
                  "data-testid": "project-description",
                  maxLength: 500,
                }}
                label={strings.descrption}
                errorMessage=""
              />
              <MuiDropdown
                menuitems={loginState?.allCategories}
                sx={{ textAlign: "start" }}
                name="categoryId"
                value={postDetails.categoryId}
                onChange={(e: any) => handleChange(e)}
                fieldvalue={"name"}
                fieldid={"id"}
                label={strings.postCategoryLabel}
                errorMessage={""}
                // onBlur={(e) => validation(e)}
                inputProps={{ "data-testid": "category" }}
              />
            </Stack>
          </div>
        </Stack>
      </div>
    </div>
  );
}

export default EditPost